import React, {useState, useEffect, useRef } from 'react'
import { FaSpinner } from 'react-icons/fa';


// Create dictionary to map search options to Typesense search parameters
const search_options_dict = {
    'Descripción del contrato': 'descripcion_del_proceso',
    'Entidad contratante': 'nombre_entidad',
    'Contratista': 'proveedor_adjudicado',
    'NIT del contratante': 'nit_entidad',
    'Documento del contratista': 'documento_proveedor',
    'Nombre de persona': 'persona_beneficiada',
    // 'Por cédula de ciudadanía': 'id_number',


}



// Function to query Typesense given the dictionary search

export function QueryTypense(searchValue, selected_dict, onQuery, pageNumber) {



  console.log('Button clicked QUERYING TYPESENSE')
  console.log("Search value: " + searchValue)
  console.log("Search dict: ");
  console.log(selected_dict);

  // Set at last click the search value
  // console.log("Setting search value as last click")
  // onLastClic(valueClic)

  // Format to follow: num_employees:>100 && country: [USA, UK]

  console.log("selected_dict['tipo_de_contrato']: ", selected_dict["tipo_de_contrato"])
  console.log("selected_dict['modalidad_de_contratacion']: ", selected_dict["modalidad_de_contratacion"])

  let list_of_filters = ["tipo_de_contrato", "modalidad_de_contratacion"]



  // If any filter is ["Todos"] then set it to empty
  for (let i = 0; i < list_of_filters.length; i++) {
    console.log("HERE")
    console.log("selected_dict[list_of_filters[i]]: ", selected_dict[list_of_filters[i]][0])
    if (selected_dict[list_of_filters[i]][0] === "Todos") {
        selected_dict[list_of_filters[i]] = ""
    }
  }


  // If query is empty, then set it to "*"
  if (searchValue == "") {
      searchValue = "*"
  }


  // Create filter_by string, adding only the filters that are not empty
  
  let filter_by = ""
  for (let i = 0; i < list_of_filters.length; i++) {
      if (selected_dict[list_of_filters[i]] != "") {
          filter_by += list_of_filters[i] + ": [" + selected_dict[list_of_filters[i]] + "]" + " && "

      }
  }

  // Remove the last " && "
  filter_by = filter_by.slice(0, -4)


  console.log("filter_by: ", filter_by)


  // Make a search query in Typesense
  // https://typesense.org/docs/0.21.0/api/documents.html#search


  const Typesense = require('typesense')

  // Initialize a Typesense client
  // let client = new Typesense.Client({
  //   'nodes': [{
  //     // 'host': 'http://67.207.95.111', // For Typesense Cloud use xxx.a1.typesense.net
  //     'host': 'bk3vgesdl1p265n0p-1.a1.typesense.net',
  //     'port': '443',      // For Typesense Cloud use 443
  //     'protocol': 'https'   // For Typesense Cloud use https
  //   }],
  //   'apiKey': 'k5NKPxhzVqAbAg9QBNbFxSsIsUc1PbM1', // i need to get the only read key
  //   'connectionTimeoutSeconds': 3
  // })
  let client = new Typesense.Client({
    'nodes': [{
      // 'host': 'http://67.207.95.111', // For Typesense Cloud use xxx.a1.typesense.net
      'host': 'tsdata.publiqly.com',
      'port': '443',      // For Typesense Cloud use 443
      'protocol': 'https'   // For Typesense Cloud use https
    }],
    'apiKey': 'bvw1aT4hKrFcLDwZ5VNsA9ITUNjKsGY9', // i need to get the only read key
    'connectionTimeoutSeconds': 4
  })

  // Send 



  // If filter_by is empty, then not include it in the search parameters
  if (filter_by == "") {
      var searchParameters = {
          'q'         : searchValue,
          'query_by'  : search_options_dict[selected_dict["tipo_busqueda"]],
          'page'      : pageNumber,
          'sort_by'   : 'fecha_de_firma:desc',
        }
  } else {

      // Search for documents in a collection
      var searchParameters = {
          'q'         : searchValue,
          'query_by'  : search_options_dict[selected_dict["tipo_busqueda"]],
          'filter_by' : filter_by,
          'page'      : pageNumber,
          'sort_by'   : 'fecha_de_firma:desc',
        }

  }


  console.log("searchParameters: ", searchParameters)
    
  client.collections('secop_dos')
      .documents()
      .search(searchParameters)
      .then(function (data) {

          // Export data out of this component
          onQuery(data);
          console.log("data: ")
          console.log(data)
      })

}




export function Searchbar({selected_dict, onQuery, onSearch}) {

    console.log("From Searchbar.jsx:")
    console.log("Dictionary with search filters: ", selected_dict)

    const isLoading = useRef(false);

    isLoading.current = false;

    console.log("Is loading: ", isLoading.current)

  
    const pageNumber = 1;

    console.log("Page number: ", pageNumber)

    const [searchValue, setSearchValue] = useState('');


    const handleButtonClick = (event) => {
        isLoading.current = true;
        console.log("Is loading before: ", isLoading.current)

        event.preventDefault();
        // Query Typesense
        // QueryTypense(searchValue, selected_dict, onQuery, pageNumber)

        // Query Typesense and then set result
        QueryTypense(searchValue, selected_dict, onQuery, pageNumber);

        isLoading.current = false;
        console.log("Is loading after: ", isLoading.current)

    };

    const handleSearchInputChange = (event) => {

      console.log("Search value: ", event.target.value)

      // Setting the search value locally
      setSearchValue(event.target.value);

      // Exporting the search value to the parent component
      onSearch(event.target.value);

    };

  return (


    <div class="pt-8 max-w-screen-lg mx-auto px-4 md:px-8 mx-auto px-4 md:px-8">
        <form>   
            <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Buscar</label>
            <div class="relative ">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none ">
                    <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                </div>
                <input type="search" id="default-search" class="block w-full p-4 pl-10 text-sm text-gray-800 border border-gray-200 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Busca acá..." value={searchValue} onChange={handleSearchInputChange} required>
                </input>

                <button 
                  type="submit" 
                  class="text-white absolute right-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" 
                  // disabled={isLoading.current}
                  onClick={handleButtonClick}
                  
                >Buscar
                  
                </button>
                {/* <button type="button" class="bg-indigo-500 ..." disabled={false}>
                <FaSpinner className="animate-spin mr-2" /> 
                  Processing...
                </button> */}
            </div>
        </form>

        {/* <ResultBox data={data} />   */}

    </div>

    

    

  )
}